import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=e1c5be82"
import script from "./Sales.vue?vue&type=script&lang=ts"
export * from "./Sales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports